import { Outlet } from 'react-router-dom';
import { Box, Container, Paper, Typography, useTheme } from '@mui/material';
import { Shield as ShieldIcon } from '@mui/icons-material';

/**
 * AuthLayout - Simple centered layout for authentication pages
 */
export const AuthLayout = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.primary.main,
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 3,
          }}
        >
          {/* Logo and Branding */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 3,
            }}
          >
            <ShieldIcon
              sx={{
                fontSize: 48,
                color: theme.palette.primary.main,
                mr: 1,
              }}
            />
            <Box>
              <Typography
                variant="h4"
                component="h1"
                sx={{
                  fontWeight: 700,
                  color: theme.palette.primary.main,
                }}
              >
                VZMR Checker
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.5 }}
              >
                Systém pro kontrolu zadávací dokumentace VZMR
              </Typography>
            </Box>
          </Box>

          {/* Content from child routes */}
          <Box sx={{ width: '100%' }}>
            <Outlet />
          </Box>

        </Paper>
      </Container>
    </Box>
  );
};
